import * as d3 from 'd3'
import { addMonths, differenceInMonths } from 'date-fns'
import { useMemo } from 'react'

import { MONTH_WIDTH } from './constants'
import type { StatementCoverage } from './types'

export const useChartData = (statementCoverage: StatementCoverage | null) => {
  return useMemo(() => {
    if (!statementCoverage) {
      return { timelineWidth: 0, monthScale: null, axisScale: null }
    }

    const { globalMin, globalMax } = statementCoverage
    const totalMonths = differenceInMonths(globalMax, globalMin) + 1
    const width = totalMonths * MONTH_WIDTH

    const monthScale = (date: Date): number => {
      const diff = differenceInMonths(date, globalMin)
      return diff * MONTH_WIDTH
    }

    const axisScale = d3
      .scaleTime()
      .domain([globalMin, addMonths(globalMax, 1)])
      .range([0, width])

    return { timelineWidth: width, monthScale, axisScale }
  }, [statementCoverage])
}
